import { Controller } from 'stimulus';

class ReadMoreController extends Controller {
  connect() {
    if (this.contentTarget.offsetHeight < 200) {
      this.contentTarget.classList.remove('read-more');

      return;
    }

    this.isExpanded = false;
    this.initialHeight = '200px';
    this.readMoreText = `+ ${window.app.i18n.readMore}`;
    this.readLessText = `- ${window.app.i18n.readLess}`;

    this.setInitialHeight();
    this.setButtons();
  }

  onTogglerClick() {
    this.isExpanded = !this.isExpanded;

    this.toggleContent();
  }

  toggleContent() {
    this.contentTarget.setAttribute('aria-expanded', this.isExpanded);
    this.contentTarget.style.height = this.isExpanded ? 'auto' : this.initialHeight;
    this.togglerTarget.innerText = this.isExpanded ? this.readLessText : this.readMoreText;
  }

  setInitialHeight() {
    this.contentTarget.style.height = this.initialHeight;
  }

  setButtons() {
    this.element.insertAdjacentHTML(
      'beforeend',
      ReadMoreController.getButton(this.readMoreText),
    );
  }

  static getButton(content) {
    return `
      <button
        type="button"
        class="btn--link color-primary mt-3 btn--reset"
        data-target="read-more.toggler"
        data-action="click->read-more#onTogglerClick"
      >
        ${content}
      </button>
    `;
  }
}

ReadMoreController.targets = [
  'content',
  'toggler',
];

export default ReadMoreController;
